// Centralized Google Ads conversion tracking for MoveAbroadIQ.
//
// The Global Site Tag (AW-18371453399) is installed once in public/index.html
// (consent-gated, exposes window.gtag). This helper fires the lead conversion
// event, and is called from ONE place — the shared submission service
// (src/config/api.js `safeFetch`) — only after a successful backend response.
//
// It never throws and is a no-op when gtag isn't available (e.g. before cookie
// consent), so it can never break form submission UX.

const LEAD_CONVERSION = {
  send_to: 'AW-18371453399/xl9KCJOL-NscENfDmLhE',
  value: 1.0,
  currency: 'AED',
};

export function trackLeadConversion() {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', { ...LEAD_CONVERSION });
    }
  } catch (e) {
    /* never break submission flow */
  }
}
